module.exports = __webpack_public_path__ + "img/f-logo.cfa802ac.svg";